<div class="product-information-container" fxLayout="column" fxLayoutAlign="space-around stretch" fxLayoutGap="30px">

    
    <p><strong>{{'psTitle' | translate}} </strong></p>
    <mat-card class="product-overview-card">
        
        <div  fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="start start"  >
            
           <div fxFlex="50" *ngIf="request.requestType != 'Inquiry request'">
                <p><strong>{{'brand' | translate}}: </strong> {{request.asset.brand}}</p>
                <p><strong>{{'model' | translate}}: </strong> {{request.asset.model}}</p>
                <p><strong>{{'serialNumber' | translate}}/{{'imeiNumber' | translate}}:</strong> {{request.assetNumber}}</p>
            </div>
            <div fxFlex="50" *ngIf="request.requestType == 'Inquiry request'">
                <h3>{{'pcInquiryTitl' | translate}}</h3>
                <p>{{'pcInquiryText' | translate}}</p>
            </div>
            <div>
                <p><strong>{{'incidentNumber' | translate}}:</strong> {{ request.incidentNumber }}</p>
                <p><strong>{{'status' | translate}}:</strong> {{request.status}}</p>
                
                <p *ngIf="request.requestType == 'Broken request'"><strong>{{'problem' | translate}}:</strong>  {{request.qualification}}</p>
                <p>{{request.description}}</p>
                
                
            </div>
        </div>

        
        
    </mat-card>
    <h4 *ngIf="request.requestActivities.length != 0">{{'cActivity' | translate}}:</h4>
    <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="start stretch" fxFlex="100" fxLayoutGap="10" fxLayoutAlign.lt-md="space-between stretch" >
        
        <div *ngFor="let activity of request.requestActivities; let i = index" fxFlex="30" >
            
                <mat-card class="activity-card"  fxLayout="row" fxLayout.lt-md="column" fxFlex="100"  fxLayoutAlign="space-between stretch" fxLayoutAlign.lt-md="space-between stretch">
                    <div fxFlex="90">
                        <p >{{activity.title}}</p>
                        <p  style="white-space:pre-wrap">{{activity.details}}</p>
                    </div>
                    <div fxLayoutAlign="center center">
                        <div fxLayoutAlign="center center" *ngIf="i != request.requestActivities.length -1" class="arrow-right">
                            <mat-icon fxShow.lt-md="false">keyboard_arrow_right</mat-icon>
                            <mat-icon fxShow.gt-md="false">keyboard_arrow_down</mat-icon>
                        </div>
                        <div *ngIf="i == request.requestActivities.length -1" class="arrow-right">
                            <mat-icon style="color: white;">keyboard_arrow_right</mat-icon>
                        </div>
                    </div>
                </mat-card>
                
            
        </div>
        
    </div>
</div>
